import * as React from 'react';
import Grid from '@mui/material/Grid2';
import StorageSites from './StorageSites';
import StorageColumn from './StorageColumn';
import Header from './Header';

type Props = {
  selectedSiteId: number | null;
  selectedStorageId: number | null;
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onSiteClick: (siteId: number) => void;
  onStorageClick: (
    storageId: number | null,
    storageName?: string,
    storage?: StorageType | null
  ) => void;
};

type StorageListMainGridProps = {
  selectedSiteId: number | null;
  selectedStorageId: number | null;
  searchTerm: string;
  onSiteClick: (siteId: number) => void;
  onStorageClick: (
    storageId: number | null,
    storageName?: string,
    storage?: StorageType | null
  ) => void;
};

const StorageListMainGrid: React.FC<StorageListMainGridProps> = ({
  selectedSiteId,
  selectedStorageId,
  onSiteClick,
  onStorageClick,
  searchTerm,
}) => (
  <Grid container size={{ xs: 12 }} alignItems="stretch">
    <StorageSites
      selectedSiteId={selectedSiteId}
      searchTerm={searchTerm}
      onSiteClick={onSiteClick}
    />

    <StorageColumn
      selectedSiteId={selectedSiteId}
      selectedStorageId={selectedStorageId}
      onStorageClick={onStorageClick}
    />
  </Grid>
);

const StorageList: React.FC<Props> = ({
  selectedSiteId,
  selectedStorageId,
  searchTerm,
  setSearchTerm,
  onSiteClick,
  onStorageClick,
}) => {
  return (
    <>
      <Header
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedSiteId={selectedSiteId}
      />

      <StorageListMainGrid
        selectedSiteId={selectedSiteId}
        selectedStorageId={selectedStorageId}
          searchTerm={searchTerm}
        onSiteClick={onSiteClick}
        onStorageClick={onStorageClick}
      />
    </>
  );
};

export default StorageList;
